import { Actions as CommonActions } from "@client/actions";
import { combineMultipleReducers, combineReducers } from "@client/lib/misc";
import { reducers as commonReducers } from "@client/reducers";
import { type GenericMap } from "@client/types";
import { type AppState, type AppStatusAppState } from "@client/types/AppState";
import { type PagesAppState } from "@client/types/AppState/pages";
import { type ReduxAction } from "@client/types/ReduxAction";
import widgets from "@client/widgets/reducers";
import { type InitSuccessActionData } from "./actions";

export const defaultPages: PagesAppState = {
  homePageId: "",
  items: []
};
const pages = (state: PagesAppState = defaultPages, action: ReduxAction<any>): PagesAppState => {
  switch (action.type) {
    case CommonActions.InitSuccess: {
      const { pages } = action.data as InitSuccessActionData;
      return pages || defaultPages;
    }
    default:
      return state;
  }
};

const status = (state: AppStatusAppState = "none", action: ReduxAction<any>): AppStatusAppState => {
  switch (action.type) {
    case CommonActions.InitSuccess: {
      return "ready";
    }
    default:
      return state;
  }
};

export const reducers = {
  pages,
  widgets
};

export const createReducer = (dynamicReducers: GenericMap<any> = {}) =>
  combineReducers<AppState>({
    ...commonReducers,
    ...reducers,
    ...combineMultipleReducers(dynamicReducers),
    status
  });
